import { render, staticRenderFns } from "./articleDetali.vue?vue&type=template&id=21599eb0&scoped=true&"
import script from "./articleDetali.vue?vue&type=script&lang=js&"
export * from "./articleDetali.vue?vue&type=script&lang=js&"
import style0 from "./articleDetali.vue?vue&type=style&index=0&id=21599eb0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21599eb0",
  null
  
)

export default component.exports